<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  created() {
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      const userInfo = localStorage.getItem("userInfo");
      const isLoginPage = this.$route.path.startsWith("/login") ;
      const isResetPasswordPage = this.$route.path === '/reset-password';
      const isPublicPage = isLoginPage || isResetPasswordPage;
      
      // 已登录但访问登录页，跳转到overview
      if (userInfo && isPublicPage) {
        this.$router.push("/main/data-tasks/overview");
        return;
      }
      
      // 未登录且不在登录页，跳转到登录页
      if (!userInfo && !isPublicPage) {
        this.$router.push("/login");
      }
    },
  },
  watch: {
    $route() {
      this.checkLoginStatus();
    }
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: Arial, sans-serif;
  iframe#webpack-dev-server-client-overlay{display:none!important}
}
</style>